export enum FileAccessibility {
  Disk = "Disk",
  DiskAndTape = "DiskAndTape",
  Tape = "Tape",
  Missing = "Missing",
}
